import { render, staticRenderFns } from "./MarketplacePage.vue?vue&type=template&id=2c15aedc&scoped=true&"
import script from "./MarketplacePage.vue?vue&type=script&lang=js&"
export * from "./MarketplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15aedc",
  null
  
)

export default component.exports